import moment from 'moment';
import { LoggerTransport, LogLevel, LogMessage, Logger } from './logger.model';
import { WrappedLogger } from './wrapped-logger';
import { Stopwatch } from './stopwatch';

export class BaseLogger implements Logger {
  constructor(private transports: LoggerTransport[], private level: LogLevel) {}

  public logMessage(level: LogLevel, message: string, data?: any, context?: any): void {
    if (!(level >= this.level)) {
      return;
    }

    const date = moment();

    const logMessage: LogMessage = {
      timestamp: date.toISOString(),
      message,
      level,
      context,
      data
    };

    for (let transport of this.transports) {
      transport.sendMessage(logMessage);
    }
  }

  public logDebug(message: string, data?: any, context?: any): void {
    this.logMessage(LogLevel.Debug, message, data, context);
  }

  public logTrace(message: string, data?: any, context?: any): void {
    this.logMessage(LogLevel.Trace, message, data, context);
  }

  public logInfo(message: string, data?: any, context?: any): void {
    this.logMessage(LogLevel.Info, message, data, context);
  }

  public logWarning(message: string, data?: any, context?: any): void {
    this.logMessage(LogLevel.Warning, message, data, context);
  }

  public logError(message: string, data?: any, context?: any): void {
    this.logMessage(LogLevel.Error, message, data, context);
  }

  public withContext(context: any): Logger {
    return new WrappedLogger(this, context);
  }

  public withMethod(method: string): Logger {
    return new WrappedLogger(this, { method });
  }

  public startStopwatch(logLevel: LogLevel, message?: string, data?: any): Stopwatch {
    return new Stopwatch(this, logLevel, message, data);
  }
}
